<script lang="ts" setup>
import type { AuctionCarPagination } from '@autobid/ui/types/Car'
import { useCarPaginationLinks } from '@autobid/ui/composables/car/useCarPaginationLinks'
import { usePrefetchPagination } from '@autobid/ui/composables/car/usePrefetchPagination'
import { paginationCva } from '@autobid/ui/utils/paginationCva'
import { computed } from 'vue'

interface Props {
  auctionCarPagination: AuctionCarPagination
  catalogNumber: number
}
const props = defineProps<Props>()

const { pagination, prevLink, nextLink } = useCarPaginationLinks(computed(() => props.auctionCarPagination))

const { prefetch } = usePrefetchPagination(pagination)
</script>

<template>
  <div v-if="pagination" class="flex w-full items-center justify-between">
    <CommonLink
      :href="prevLink"
      :aria-label="$t('pagination.prev-page')"
      :class="paginationCva({ type: 'previous', disabled: !prevLink })"
      @mouseenter="prefetch('prev')"
    >
      <Icon mode="svg" name="mingcute:left-line" class="z-10 text-2xl" />
    </CommonLink>
    <span
      class="px-3 py-1 text-center text-xl text-black text-primary md:px-10 xl:text-2xl"
    >
      <span>{{ $t('barometer.catalog-number') }}:</span>
      {{ catalogNumber }}
    </span>
    <CommonLink
      :href="nextLink"
      :class="paginationCva({ type: 'next', disabled: !nextLink })"
      :aria-label="$t('pagination.next-page')"
      @mouseenter="prefetch('next')"
    >
      <Icon mode="svg" name="mingcute:right-line" class="z-10 text-2xl" />
    </CommonLink>
  </div>
</template>
